import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { maxValue, minValue, number, NumberInput, ReferenceInput, required } from "react-admin";

const StudentGraduationYear = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      <NumberInput
        label="Година"
        source="year"
        type="number"
        step={1}
        validate={[required(), minValue(2020), maxValue(2999), number()]}
        onChange={e => handleParamChange("year", e.target.value)}
        onWheel={e => e.target.blur()}
      />
    </>
  );
};

export default StudentGraduationYear;
